import React, { FC, useMemo } from 'react';
import { ResizeMode } from '@wix/thumbnail-generator';
import { ResizedImage } from '../../../../ResizedImage';
import styles from './SiteIconThumbnail.scss';
import { propOr } from 'ramda';
import { IOuter } from './SiteIconThumbnail.types';

const ICON_PREVIEW_DIMENSIONS = {
  width: 128,
  height: 128,
};

export const SiteIconThumbnail: FC<IOuter> = ({ file, isPanel, width, height, params = {} }) => {
  const widthToApply = isPanel ? ICON_PREVIEW_DIMENSIONS.width : width;
  const heightToApply = isPanel ? ICON_PREVIEW_DIMENSIONS.height : height;

  const isSmallerThanViewport = widthToApply > file.width && heightToApply > file.height;
  const resizedImageParams = useMemo(
    () => ({
      mode: ResizeMode.Fit,
      keepOriginalSize: propOr(false, 'keepOriginalSize', params) && isSmallerThanViewport,
    }),
    [params, isSmallerThanViewport],
  );

  return (
    <div className={styles.siteIcon}>
      <ResizedImage
        src={file.previewUrl}
        isSecure={false}
        source={file.source}
        width={widthToApply}
        height={heightToApply}
        params={resizedImageParams}
        shouldUseBackgroundImageImmediately={false}
      />
    </div>
  );
};
